import { Option } from 'funfix-core';
import { List, Record } from 'immutable';
export const makePaginatedValues = Record({
  values: List(),
  nextOffset: Option.empty(),
  totalCount: 0
});